import { axiosPrivateInstance } from 'libs/axios';
import { UPDATE_WEBLINK_APPROVE_STATUS } from 'utils/serviceUrls';

const updateApproveWeblinkStatusService = async (
	id: string,
	message: string,
	isProductUpdate: number,
	type: number,
) => {
	const paramData = {
		encId: id,
		comment: message,
		workFlowTypeId: isProductUpdate,
		typeId: type,
	};
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(UPDATE_WEBLINK_APPROVE_STATUS, paramData)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default updateApproveWeblinkStatusService;
